export const SIDEBAR_WIDTH = 240; //px

export const FOOTER_HEIGHT = 36; //px

export const HEADER_HEIGHT = 50; //px

export const DRUG_BREADCRUMB_HEIGHT = 36; //px

export const PA_SEPARATOR_SPACING = 50; //px
